import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";

import MainContainer from "../../layout/MainContainer";
import { Loader, showError } from "../../constants";
import { useLazyGetBlogsByIdQuery } from "../../services/blogs";
import { BlogByIdResponse } from "../../types/General";
import moment from "moment";

const BlogDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [blogData, setBlogData] = useState<BlogByIdResponse>();

  const [getBlogById, { isLoading }] = useLazyGetBlogsByIdQuery();

  const getBlogDetail = async (id: string) => {
    try {
      const response = await getBlogById({
        blog_id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        setBlogData(response?.data[0]);
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (id) {
      getBlogDetail(id);
    }
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={isLoading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1>Blog Details</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-blogs");
            }}
          >
            Back
          </Button>
        </div>
        <Card className="cards">
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2} className="view_box">
              <Grid item xs={12}>
                <figure className="blog_img">
                  <img src={blogData?.blogImages || ""} alt="" />
                </figure>
              </Grid>
              <Grid item xs={10} className="view_box_list">
                <Grid container spacing={3}>
                  <Grid item xs={4}>
                    <Box>
                      <Typography component="h5">Title</Typography>
                      <Typography component="p">
                        {blogData?.title || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box>
                      <Typography component="h5">Date</Typography>
                      <Typography component="p">
                        {moment(blogData?.createdAt).format("DD/MM/YYYY") ||
                          "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box>
                      <Typography component="h5">Status</Typography>
                      <Typography component="p">
                        {blogData?.isBlocked ? "Deactivated" : "Active"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box>
                      <Typography component="h5">Description</Typography>
                      <Typography component="p" sx={{ wordBreak: "break-all" }}>
                        {blogData?.description || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    </MainContainer>
  );
};

export default BlogDetails;
